const PRODUCT_SECTION_SELECTOR = '.product-information';
const DETAILS_SELECTOR = '[data-elohm-pdp-details]';
const observedSections = new WeakSet();

function padIndex(value) {
  return String(value).padStart(2, '0');
}

function indexMediaSet(items) {
  const mediaItems = Array.from(items).filter((item) => item.matches('.product-media-container'));
  const total = mediaItems.length;

  mediaItems.forEach((item, index) => {
    item.dataset.elohmMediaIndex = `${padIndex(index + 1)} / ${padIndex(total)}`;
  });
}

function indexProductMedia(section) {
  const media = section.querySelector('.product-information__media');
  if (!media) return;

  media.querySelectorAll('slideshow-slides').forEach((track) => {
    indexMediaSet(track.children);
  });

  media.querySelectorAll('.media-gallery__grid').forEach((list) => {
    indexMediaSet(list.children);
  });
}

function enhanceVariantFieldset(fieldset) {
  const legend = fieldset.querySelector('legend');
  if (!legend) return;

  let state = legend.querySelector('.elohm-pdp-selection-state');
  if (!state) {
    state = document.createElement('span');
    state.className = 'elohm-pdp-selection-state';
    state.setAttribute('aria-live', 'polite');
    legend.append(state);
  }

  const updateState = () => {
    const selected = fieldset.querySelector('input:checked');
    state.textContent = selected ? `SELECTED / ${selected.value}` : 'SELECT / —';
  };

  if (fieldset.dataset.elohmVariantEnhanced !== 'true') {
    fieldset.addEventListener('change', updateState);
    fieldset.dataset.elohmVariantEnhanced = 'true';
  }

  updateState();
}

function enhanceProductDetails(section) {
  const details = section.querySelector(DETAILS_SELECTOR);
  if (!details) return;

  details.querySelectorAll('.variant-option').forEach(enhanceVariantFieldset);
}

function observeProductSection(section) {
  if (observedSections.has(section)) return;

  let updateQueued = false;
  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.type === 'childList') || updateQueued) return;

    updateQueued = true;
    requestAnimationFrame(() => {
      updateQueued = false;
      indexProductMedia(section);
      enhanceProductDetails(section);
    });
  });

  observer.observe(section, { childList: true, subtree: true });
  observedSections.add(section);
}

function initializeProductSection(section) {
  indexProductMedia(section);
  enhanceProductDetails(section);
  observeProductSection(section);
}

function initialize(root = document) {
  if (root.matches?.(PRODUCT_SECTION_SELECTOR)) {
    initializeProductSection(root);
  }

  root.querySelectorAll?.(PRODUCT_SECTION_SELECTOR).forEach(initializeProductSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
} else {
  initialize();
}

document.addEventListener('shopify:section:load', (event) => initialize(event.target));
document.addEventListener('variant:update', () => requestAnimationFrame(() => initialize()));
